var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c3.859 0 7-3.141 7-7s-3.141-7-7-7-7 3.141-7 7 3.14 7 7 7m0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m-1-8H7v5.518a8.96 8.96 0 0 1 4-1.459zm6 0h-4v4.059a8.96 8.96 0 0 1 4 1.459z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.019 15.811-.468 2.726L12 17.25l2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L12 11l-1.225 2.481-2.738.398z"
  })));
};
export default SvgMedal;